import './footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';

export const Footer = () => {
    const location = useLocation();
    const isActive = (path:any) => location.pathname === path ? "footerdiv2atag footerdiv2atagactive" : "footerdiv2atag";
    return(
        <>  
            <div className="containerfooter">
                <div id='footer'>
                    <div className="footer-top">
                            <div className="footerdiv1">
                                    <div className="footerdiv1img">
                                        <a href="#" rel="noopener noreferrer">
                                        <img src="./assets/images/Logo/Logo_new.png" alt="Logo" />
                                        </a>
                                    </div>
                                    
                                    <div className="footerdiv1text">
                                        <p>Come, Be a Part of the Journey of Faith – Welcome to Geelong Pentecostal Assembly! Discover inspiration, community, and spiritual growth. Join us online or in person, and stay connected with everything happening at our church.</p>
                                    </div>
                            </div>
                            <div className="footerdiv2cstmpages">
                                <h2>Pages</h2>
                                <a href="/" className='footerdiv2atag' rel="noopener noreferrer"><p className={`${isActive('/')}`}>Home</p></a>
                                <a href="/about" className='footerdiv2atag' rel="noopener noreferrer"><p className={`${isActive('/about')}`}>About</p></a>
                                <a href="/webelieve" className='footerdiv2atag' rel="noopener noreferrer"><p className={`${isActive('/webelieve')}`}>We Believe</p></a>
                                <a href="/ministries" className='footerdiv2atag' rel="noopener noreferrer"><p className={`${isActive('/ministries')}`}>Ministries</p></a>
                                <a href="/planyourvisit" className='footerdiv2atag' rel="noopener noreferrer"><p className={`${isActive('/planyourvisit')}`}>Plan Your Visit</p></a>
                                <a href="/contact" className='footerdiv2atag' rel="noopener noreferrer"><p className={`${isActive('/contact')}`}>Contact</p></a>
                                <a href="/prayerrequest" className='footerdiv2atag' rel="noopener noreferrer"><p className={`${isActive('/prayerrequest')}`}>Prayer</p></a>

                            </div>
                            <div className="footerdiv2cstmcontact">
                                <h2>Contact</h2>
                                <div className='footerdiv2cstmcontactmix'>
                                    <FontAwesomeIcon icon={faLocationDot} color='#3c79b0' className='footerdiv2cstmcontactmixiconfont'/>
                                    <p>82 Wilsons Road, Newcomb, VIC</p>
                                </div>
                                <div className='footerdiv2cstmcontactmix'>
                                    <FontAwesomeIcon icon={faEnvelope} color='#3c79b0' className='footerdiv2cstmcontactmixiconfont'/>
                                    <p><a href="mailto:info@geelongpentecostalassembly.com.au" rel="noopener noreferrer">info@geelongpentecostalassembly.com.au</a></p>
                                </div> 
                                <div className='footerdiv2cstmcontactmix'>
                                    <FontAwesomeIcon icon={faPhone} color='#3c79b0' className='footerdiv2cstmcontactmixiconfont'/>
                                    <p><a href="tel:+61494357534" rel="noopener noreferrer">+61 494 357 534</a></p>
                                </div> 
                            </div>
                            <div className="footerdiv2cstmsocial">
                                <h2>Social</h2>
                                <ul>
                                        <a href="#" target='_blank' rel="noopener noreferrer">
                                            <li>
                                                <i className="fab fa-facebook"></i>
                                            </li>
                                        </a>
                                        <a href="#"  target='_blank' rel="noopener noreferrer">
                                            <li>
                                                <i className="fab fa-instagram"></i>
                                            </li>
                                        </a>
                                        <a href="#" target='_blank' rel="noopener noreferrer">
                                            <li>
                                                <i className="fab fa-twitter"></i>
                                            </li>
                                        </a>
                                        <a href="#" target='_blank' rel="noopener noreferrer">
                                            <li>
                                                <i className="fab fa-youtube"></i>
                                            </li>
                                        </a>
                                </ul>
                            </div> 
                    </div>
                    <hr />
                    <div className="footer-bottom">
                        <p>Copyright © 2026 Geelong Pentecostal Assembly. All Rights Reserved.</p>
                    </div>
                </div>          
            </div>
        </>
    )
}


